import type { ReelDraft } from '@/lib/reel';
import { defaultReelSound } from '@/lib/reel-sound';
export function ReelSound({
  draft,
  onChange,
  disabled,
}: {
  draft: ReelDraft;
  onChange: (draft: ReelDraft) => void;
  disabled: boolean;
}) {
  const sound = draft.sound ?? defaultReelSound(Boolean(draft.audio || draft.audioFile));
  return (
    <fieldset className="picture-tools" disabled={disabled}>
      <strong>Sound levels</strong>
      {(['originalVolume', 'musicVolume'] as const).map((key) => (
        <label key={key}>
          {key === 'originalVolume' ? 'Original' : 'Music'}{' '}
          <input
            aria-label={key === 'originalVolume' ? 'Original volume' : 'Music volume'}
            type="range"
            min={0}
            max={1}
            step={0.05}
            value={sound[key]}
            onChange={(e) =>
              onChange({ ...draft, sound: { ...sound, [key]: Number(e.target.value) } })
            }
          />
          <output>{Math.round(sound[key] * 100)}%</output>
        </label>
      ))}
      <label>
        Start music at{' '}
        <input
          aria-label="Music starts at"
          type="number"
          min={0}
          max={86400}
          step={0.1}
          value={sound.musicStartMs / 1000}
          onChange={(e) =>
            onChange({
              ...draft,
              sound: {
                ...sound,
                musicStartMs: Math.round(
                  Math.max(0, Math.min(86400, Number(e.target.value))) * 1000,
                ),
              },
            })
          }
        />{' '}
        seconds into the track
      </label>
      <span className="composer-hint">Music fades out during the final second.</span>
    </fieldset>
  );
}
